import dayjs from 'utils/dayjs';

/**
 * Calculate and return the stay date range (start and end)
 * It always starts on today and spans over 1 year
 * @return {Object} an object with 'startDate' and 'endDate'
 */
const getStayDatesRange = () => ({
    startDate: dayjs.utc().format('YYYY-MM-DD'),
    endDate: dayjs.utc().add(11, 'months').endOf('month').format('YYYY-MM-DD'),
});

/**
 * Calculate the min and max booking datetimes from today's date and the range (number of days)
 * @param  {Number} range - in days
 * @return {Object} an object with 'minBookingDatetime' and 'maxBookingDatetime'
 */
const calculateBookingDatesFromRange = (range) => ({
    minBookingDatetime: dayjs.utc().subtract(range, 'day').startOf('day').toISOString(),
    maxBookingDatetime: dayjs.utc().subtract(1, 'day').endOf('day').toISOString(),
});

/**
 * Parse a stayDate month string from the API into a valid ISO format
 * @param  {String} dateStr
 * @return {String}
 */
const parseMonthIntoDate = (dateStr) => dayjs(dateStr, 'YYYY-MM').startOf('month').format('YYYY-MM-DD');

export { getStayDatesRange, calculateBookingDatesFromRange, parseMonthIntoDate };
